export default "__VITE_ASSET__CY$12d7I__"